export default __webpack_public_path__ + "static/media/bannerImage3.113040a3.jpg";